// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8R1QL","close":"styles_close__pBa6U","button":"styles_button__4GvK0"};